import { AudienceGraphql, NotificationsTableFiltersFields } from '../../../../../generated/apollo-hooks';
import { AppTableFilterOption, AppTableFiltersMetadata } from '../../../../models/filters';
import { ALL_RECIPIENTS_KEY, END_USERS_RECIPIENTS_KEY, USER_API_LABEL } from '@communication-center/data-objects';
import { API_CELL_TEXT } from '../models';

export function parseNotificationFiltersFields(
    filterFields?: NotificationsTableFiltersFields | null,
    audiences?: AudienceGraphql[]
): AppTableFiltersMetadata | undefined {
    if (!filterFields) {
        return undefined;
    }

    const parsedFilters: AppTableFiltersMetadata = {};

    if (filterFields.sender) {
        parsedFilters['user.label'] = filterFields.sender
            .map(label => (label === USER_API_LABEL ? { label: API_CELL_TEXT, value: USER_API_LABEL } : { label, value: label }))
            .flat();
    }

    if (filterFields.audiences) {
        const valuesOptions: AppTableFilterOption[] = [];

        if (filterFields.audiences.some(audienceId => audienceId === ALL_RECIPIENTS_KEY)) {
            valuesOptions.push({ label: ALL_RECIPIENTS_KEY, value: ALL_RECIPIENTS_KEY });
        }

        if (filterFields.audiences.some(audienceId => audienceId === END_USERS_RECIPIENTS_KEY)) {
            valuesOptions.push({ label: END_USERS_RECIPIENTS_KEY, value: END_USERS_RECIPIENTS_KEY });
        }

        filterFields.audiences.flat()?.forEach(id => {
            const audience = audiences?.find?.(item => id == item.id);

            if (audience) {
                valuesOptions.push({ label: audience.title, value: audience.id });
            }
        });

        parsedFilters['audiencesIds'] = valuesOptions;
    }

    return parsedFilters;
}
